import React, {useState} from 'react';
import parse from 'html-react-parser';
import Heading from 'js/components/Common/Heading/Heading';
import useFetchData from 'js/hooks/useFetchData/useFetchData';
import Container from 'js/components/Common/Container/Container';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import fetchData from './fetchData';
import classes from './Welcome.module.pcss';

interface Props {
    pageId: number
}

const Welcome = ({pageId}: Props) => {
    const [title, setTitle] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    const {isLoading, error} = useFetchData({
        query: `${fetchData(pageId)}`,
        condition: !!pageId,
        updateData: (data: any): void => {
            const result = data?.page?.PostLoginPage;
            setTitle(result?.titleWelcome);
            setDescription(result?.descriptionWelcome);
        }
    });

    return (
        <DataValidator data={!isLoading && !error && title?.length > 0 && description?.length > 0}>
            <section className={classes.Welcome}>
                <Container additionalClass={classes.Wrap}>
                    <Heading text={title} />
                    <div className={classes.Description}>{parse(description || '')}</div>
                </Container>
            </section>
        </DataValidator>
    );
};

export default Welcome;
